export const TUANAN_TENANT_CODE = 'TUANANSHEQU'
/** 五里墩街道本级；子社区 tenantCode 不会与此重复 */
export const WULIDUN_TENANT_CODE = 'KTHGRIOTVE'
export const TUANAN_SCREEN_ROUTE = 'tuananScreen'
export const WULIDUN_SCREEN_ROUTE = 'wulidunScreen'

export function isTuananTenantCode(code?: string | null) {
  return String(code || '').trim() === TUANAN_TENANT_CODE
}

export function isWulidunStreetTenantCode(code?: string | null) {
  return String(code || '').trim() === WULIDUN_TENANT_CODE
}

/** 仅团安走 UE4 屏；五里墩本级及其余租户一律走高德屏 */
export function isUeScreenTenantCode(code?: string | null) {
  const normalized = String(code || '').trim()
  return normalized === TUANAN_TENANT_CODE
}

/** 无 tenantCode 时不跨屏，避免误切 */
export function resolveScreenRouteName(
  tenantCode: string | undefined | null,
  currentRouteName: string
) {
  const code = String(tenantCode || '').trim()
  if (!code) return currentRouteName
  return isUeScreenTenantCode(code) ? TUANAN_SCREEN_ROUTE : WULIDUN_SCREEN_ROUTE
}
